import * as React from 'react';
import Form, { Page } from '../../containers/FormPage/FormPage';

import style from './Stepper.module.css';

type StepProps = {
    title: string,
    onClick?: Function
    index?: number,
    currentStep?: number,
    stepCount?: number
}

type StepperProps = {
    api: any
}

const Step = (props: StepProps) => {
    const active = props.currentStep == props.index;

    const node = active ? style.node : style.nodeSmall;
    const styling = active ? style.active : style.inactive;

    const breaker = props.index == 0 ? style.breakerTop : props.index == props.stepCount ? style.breakerBottom : style.breaker;

    return (
        <div onClick={()=>{props.onClick?.()}} id={style.step}>
            <div id={node} className={styling}></div>
            <div id={style.title}>{props.title}</div>
            <div id={breaker}></div>
        </div>
    )
}

const Stepper = (props: StepperProps) => {
    return (
        <div id={style.container}>
            {
                props.api.form.pages.map((step: any, index: number) => {
                    return (
                        <Step key={index} title={step.header} index={index} currentStep={props.api.page} stepCount={props.api.form.pages.length-1}></Step>
                    )
                })
            }
        </div>
    )
};

export default Stepper;
export type { StepProps, StepperProps }